<div class="road-type-conflict-dialog">
  <fm-close-icon-button
    class="road-type-conflict-dialog__close-icon"
    a7sId="road-type-conflict-dialog-close"
    (closeClick)="onClose()"
  ></fm-close-icon-button>
  <span class="road-type-conflict-dialog__title" i18n="@@S_LIVEMAP_ROAD_TYPE_CONFLICT_TITLE">Cannot edit combined road types</span>
  <span class="road-type-conflict-dialog__description" i18n="@@S_LIVEMAP_ROAD_TYPE_CONFLICT_DESCRIPTION">
    You selected segments with different road types (one-way and two-way). You must edit each segment individually.
  </span>
  <div class="road-type-conflict-dialog__buttons">
    <button
      mat-flat-button
      color="accent"
      class="btn-uppercase"
      a7s-id="road-type-conflict-dialog-ok"
      i18n="@@S_OK_BUTTON_LABEL"
      i18n-aria-label="@@S_OK_BUTTON_LABEL"
      aria-label="OK"
      (click)="onClose()"
    >
      OK
    </button>
  </div>
</div>
